module.exports = __webpack_public_path__ + "6037c64ccccbb7809ac5569df7fcf243.svg";